import { CardHeader, CardPreview, Drawer } from "@verde/compose-ui";
import { useFetchFieldInsight } from "@verde/entities";
import { DashboardIcon, HomeIcon, SendIcon, UserIcon } from "@verde/icons";
import { Copyable, Link, Skeleton, Text } from "@verde/ui-core";
import { formatToPhone } from "@verde/utils";
import type { CardDetailsProps } from "./types";

export default function CardDetails({
  open,
  onClose,
  insightId,
}: CardDetailsProps) {
  const { data, isLoading } = useFetchFieldInsight(insightId);

  return (
    <Drawer
      open={open}
      onClose={onClose}
      header={{
        title: "Verde Push",
        icon: <SendIcon className="-rotate-45" />,
        description:
          "Veja quais os produtores que se encaixam neste modelo de marketing.",
      }}
      footer={{
        primary: {
          children: "Fechar",
          onClick: onClose,
        },
      }}
    >
      <div className="grid gap-6">
        {isLoading ? (
          <Skeleton height={150} />
        ) : (
          <div className="grid bg-neutral-light-1 rounded p-4 ">
            <div className="grid rounded border-brand-yellow border p-3 gap-4">
              <CardHeader
                icon={<DashboardIcon />}
                title="Por que estes produtores foram selecionados?"
              />
              <Text className="text-neutral-dark-1 font-normal ">
                {data?.description}
              </Text>
              <Text className="font-semibold text-neutral-dark-1">
                Aproveite para enviar um alô com nosso material informativo!
              </Text>
            </div>
          </div>
        )}
        <hr />
        <CardHeader
          title="Produtores"
          description="Produtores selecionados elegível para a campanha de marketing"
          icon={<HomeIcon />}
        />
        <div className="grid gap-3 max-h-96 scrollbar-thin pr-1 overflow-y-auto">
          {isLoading ? (
            <>
              <Skeleton height={60} />
              <Skeleton height={60} />
              <Skeleton height={60} />
            </>
          ) : (
            data?.clients?.map((client) => {
              return (
                <CardPreview
                  key={`client_card_${client.id}`}
                  icon={<UserIcon />}
                  title={client.name}
                  description={
                    client.phone_number && (
                      <div className="flex gap-1  text-sm text-brand-green-dark">
                        WhastApp:
                        <Copyable>
                          {formatToPhone(client.phone_number)}
                        </Copyable>
                      </div>
                    )
                  }
                />
              );
            })
          )}
        </div>
      </div>
    </Drawer>
  );
}
